import React from "react";

const Header = () => {
  return (
    <section className="header d-flex  flex-column">
      <div className="mt-5 mx-4 d-flex flex-column align-items-center col-md-5 mobile">
        <h1>ABE</h1>
        <h5>"One stop shop for POS devices/software"</h5>
      </div>
    </section>
  );
};

export default Header;
